import styled from 'styled-components'; 

export const StoriesBox = styled.div`
    margin-bottom: 24px;
    width: 100%;
    break-inside: avoid;
`;
export const Heading = styled.div`
  display: flex;
  cursor:pointer;
  gap:10px;
  margin-bottom: 15px;
  margin-top: 15px;
`;
export const ReviewImage = styled.div`
   position: relative;
    width: 100%;
    border-radius: 20px;
    max-height: 200px;
    object-fit: cover;
    height: 100%;
    margin-bottom: 0px;

img{
    width: 100%;
    border-radius: 20px;
    max-height: 200px;
    object-fit: cover;
    height: 100%;
  }
  

`;
export const Likethamb = styled.div`
    position: absolute;
    right: 5px; 
    background: #ffff;
    border-radius: 16px;
    padding: 16px 11px 6px 11px;
    top: 5px;
    color: #000000;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: "Jost", sans-serif;
    cursor: pointer;
   img{
    width: 20px;
    height: 20px;
   } 
.likeimg {
    margin-top: 0;
}
`;
export const HeaidnImage = styled.div`
display: flex;
gap: 10px;

img{
    width: 72px;
    height: 72px;
    min-width: 72px;
}
`;


export const CientName = styled.div`
   .reviewnumber{
    display:none;
   }
`;
export const Name = styled.h5`
    color: #000000;
    font-size: 16px;
    line-height: 21px;
    font-family: "Jost", sans-serif;
    font-weight:600;
    margin-bottom:2px;
    margin-top: 0px;
`;

export const ClientServed = styled.span`
    color: #000000;
    font-size: 14px;
    line-height: 21px;
    font-family: "Jost", sans-serif;
    font-weight:300;
    display: block;
    margin-bottom: 3px;
`;

export const ClientBox = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
`;

export const SmallText = styled.p`
   color: #000000;
   font-size: 14px;
   line-height: 21px;
   font-family: "Jost", sans-serif;
   font-weight:400;
   margin-bottom:12px;
 
`;

export const Comment = styled.span`
     color: #000000;
    font-size: 14px;
    line-height: 21px;
    display: inline-flex;
    gap: 5px;
    font-family: "Jost", sans-serif;
    font-weight:700;
`;

export const ClientDescription = styled.div`
  padding: 5px 20px 20px 20px;
//   img{
//     width: 20px;
//     height: 20px;
//   }
`;

export const SocailLink = styled.div`
display: flex;
justify-content: space-between;
align-items: end;
`;


export const LinkTitle = styled.h5`
    color: #000000;
    font-size: 14px;
    line-height: 21px;
    font-family: "Jost", sans-serif;
    font-weight:400;
    margin-top:12px;
    margin-bottom:10px;
`;


export const SocailList = styled.ul`
display: flex;
padding: 0;
list-style: none;
gap: 10px;
margin: 0;
`;
export const SocailItem = styled.li`
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
       

    a{
        display: flex;
         img{
          margin-top: 0;
        }
    } 
    &:first-child {
        background: #F7931E;
    } 
    &:nth-child(2){
        background: #4267B2;
    }
    &:nth-child(3){
        background: #000000;
    }
`;
export const ReviewDetails = styled.div`

  
`;

export const ReviewFlag = styled.span`
color: #555555;
font-size: 16px;
line-height: 23px;
font-family: "Jost", sans-serif;
font-weight:500;
cursor: pointer;
transition: all 0.3s ease-in-out;
display: flex;
align-items: center;
gap: 5px;
.flag-icon{
    width:20px;
    height:20px;
    margin-top: 0px;
}

.flaged{
color:#FFA317 !important;
    &:hover{
         color:#FFA317;
        path{
         fill:#FFA317;
         stroke:#FFA317;
        }
     }
}
`;
export const CommentBox = styled.span`
.accordion-item{
    border:none;
}
.accordion-button{
    padding:0;
    background: transparent !important;
    box-shadow: none !important;
    &:after{
        margin-left: 10px;
    }
}

.accordion-body{
    padding: 11px 9px;
}
button.btn.btn-primary{
 background: #33a7ae;
}


`;


export const AccordionIcon = styled.div`

`;
export const Accordiontext = styled.div`
    color: #000000;
    font-size: 16px;
    line-height: 21px;
    font-family: "Jost", sans-serif;

  span {
    font-weight: 300;
}
`;

export const AccordionHeading = styled.div`
    display: flex;
    gap:10px;
    align-items: center;
    margin-bottom: 15px;
`;

